"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusTitleType = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AnchorLink = _interopRequireDefault(require("shared/dist/components/AnchorLink"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _styles2 = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const statusTitleType = exports.statusTitleType = {
  PENDING: "PENDING",
  REJECTED: "REJECTED"
};
const SNETStatusBanner = _ref => {
  let {
    classes,
    title,
    img,
    description,
    actions,
    type,
    anchorDetails
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.statusBannerContainer
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.statusBannerMedia
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: img,
    alt: "Status-Media"
  })), /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: classes.statusBannerContent
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h6",
    className: classes[statusTitleType[type]]
  }, title), /*#__PURE__*/_react.default.createElement(_Typography.default, null, description), actions.map(action => /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    key: action.children
  }, action))), anchorDetails ? anchorDetails.map(detail => /*#__PURE__*/_react.default.createElement(_AnchorLink.default, {
    label: detail.label,
    href: detail.linkTo,
    key: detail.label,
    newTab: detail.newTab
  })) : null));
};
SNETStatusBanner.propTypes = {
  title: _propTypes.default.string.isRequired,
  img: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  actions: _propTypes.default.array,
  type: _propTypes.default.oneOf([statusTitleType.PENDING, statusTitleType.REJECTED])
};
var _default = exports.default = (0, _styles.withStyles)(_styles2.useStyles)(SNETStatusBanner);